"use client";

import { type SelectTranslationWithTranscriptsAndLexemes } from "~/server/db/translations/schema";

import TranscriptListCounts from "../../words/WordCounts";
import Transcript from "./Transcript";
import TranscriptList from "./TranscriptList";

export default function Translation({
  translation,
  hasMore,
}: {
  translation: SelectTranslationWithTranscriptsAndLexemes;
  hasMore: boolean;
  nextCursor?: number;
}) {
  const { transcripts, lemmasCounts } = translation;

  return (
    <div className="w-full">
      <TranscriptListCounts lemmasCount={lemmasCounts?.totalCount ?? 0} />
      <TranscriptList
        translationId={translation.id}
        transcripts={transcripts}
        hasMore={hasMore}
        ListItemComponent={Transcript}
        reContain={false}
      />
    </div>
  );
}
